import AXIOS from "@/api";
import HTTP from "../../api";

export default {
  async getPrematchCount({ commit }) {
    try {
      const response = await AXIOS.get("v2/prematch/count", { params: {} });
      if (response.status === 200 && response.data.success) {
        commit("SET_PREMATCH_COUNT", response.data.count);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  },
    async getPrematchMatches({ commit }) {
    return HTTP.get("/v2/prematch").then((res) => {
      commit("SET_PREMATCH_MATCHES", res.data.matches);
    });
  },
};
